import { Button } from '../../../subkit-ui';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LandingPageCallToAction = function LandingPageCallToAction(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "py-16 px-4 md:px-0 flex flex-column items-center",
    children: [/*#__PURE__*/_jsx("img", {
      src: "/images/squiggle-13-lg.png",
      style: {
        width: '56px',
        height: '60px'
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-6 font-serif text-xl md:text-2rem leading-snug md:leading-snug text-gray-900 text-center",
      children: props.title
    }), /*#__PURE__*/_jsx("div", {
      className: "flex justify-center",
      children: /*#__PURE__*/_jsx(Button, {
        classes: "mt-12 py-3 px-12 font-dmsans fw-700",
        text: props.buttonText,
        href: props.buttonLink
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-4 text-sm text-gray-900 fw-500 text-center",
      children: props.smallText
    })]
  });
};

export default LandingPageCallToAction;